import React, { lazy, Suspense } from "react";
import { LazyMotion, domAnimation, AnimatePresence } from "framer-motion";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Loader from "../components/Loader";
import ScrollToTop from "./ScrollToTop";
import RecruitmentDetails from "../pages/Recruitment/RecruitmentDetail";
import RecruitmentLogs from "../pages/Recruitment/RecruitmentLogs";
import RecruitmentTrackers from "../pages/Recruitment/RecruitmentTracker";
import ManageDocument from "../pages/Recruitment/ManageDocument/index.jsx";

// Clients
const ClientLogin = lazy(() => import("../pages/Clients/ClientLogin"));
// const ClientRegister = lazy(() => import("../pages/Clients/ClientRegister"));
const ClientDashBoard = lazy(() => import("../pages/Clients/ClientsDashBoard"));
const ClientJobOpenings = lazy(() =>
  import("../pages/Clients/ClientJobOpenings")
);
const ClientCVPreBatch = lazy(() =>
  import("../pages/Clients/ClientBatch/clientPreScreenBatch.jsx")
);
const ClientBatch = lazy(() => import("../pages/Clients/ClientBatch"));
const ClientBatch1 = lazy(() => import("../pages/Clients/ClientBatch/index2.jsx"));
const ClientViewCvBatch = lazy(() => import("../pages/Clients/ClientBatch/viewCvs.jsx"));
// const ClientContacts = lazy(() => import("../pages/Clients/ClientContacts"));

// Recruitment
const RecruitmentLogin = lazy(() =>
  import("../pages/Recruitment/RecruitmentLogin")
);
const RecruitmentDashboard = lazy(() =>
  import("../pages/Recruitment/RecruitmentDashBoard")
);
const RecruitmentJobOpenings = lazy(() =>
  import("../pages/Recruitment/RecruitmentJobOpenings")
);
const RecruiterJobs = lazy(() => import("../pages/Recruitment/RecruitersJobs"));
// const RecruitmentContacts = lazy(() =>
//   import("../pages/Recruitment/RecruitmentContacts")
// );
const RecruitmentClients = lazy(() =>
  import("../pages/Recruitment/RecruitmentClients")
);
const RecruitmentInterviews = lazy(() =>
  import("../pages/Recruitment/RecruitmentInterviews")
);
const RecruitmentCVParsing = lazy(() =>
  import("../pages/Recruitment/RecruitmentCVParsing")
);
const RecruitmentClientInformation = lazy(() =>
  import("../pages/Recruitment/RecruitmentClientInformation")
);
const RecruitmentJobAssignment = lazy(() =>
  import("../pages/Recruitment/RecruitmentJobAssignment")
);
const RecruitmentCVBatch = lazy(() =>
  import("../pages/Recruitment/RecruitmentCVBatch")
);
const RecruitmentCVBatch1 = lazy(() =>
  import("../pages/Recruitment/RecruitmentCVBatch1")
);
const RecruitmentMultipleCVBatch = lazy(() =>
  import("../pages/Recruitment/RecruitmentCVBatch/batchCreateMultiple.jsx")
);
const RecruitmentMultipleCVBatch1 = lazy(() =>
  import("../pages/Recruitment/RecruitmentCVBatch1/batchCreateMultiple.jsx")
);
const RecruitmentBatchViewCv = lazy(() =>
  import("../pages/Recruitment/RecruitmentCVBatch1/batchViewCv.jsx")
);
const PreManageClient = lazy(() =>
  import("../pages/Recruitment/PreManageClient")
);
const PreManageJobs = lazy(() => import("../pages/Recruitment/PreManageJobs"));

// Misc
const PageNotFound = lazy(() => import("../components/NoPageFound"));
const NotAuthorize = lazy(() => import("../components/NotAuthorize"));

const Routing = ({ language, changeLanguage }) => {
  return (
    <div>
      <Suspense fallback={<Loader minHeight={"80vh"} />}>
        <Router>
          <AnimatePresence>
            <LazyMotion features={domAnimation}>
              <ScrollToTop />
              <Routes>
                {/* Clients */}
                <Route
                  path="/client"
                  element={
                    <ClientLogin
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                {/* <Route
                  path="/client/register"
                  element={<ClientRegister />}
                ></Route> */}
                {/* <Route
                    path="/client/contacts"
                    element={<ClientContacts />}
                  ></Route> */}
                <Route
                  path="/client/dashboard"
                  element={
                    <ClientDashBoard
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/client/jobs"
                  element={
                    <ClientJobOpenings
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/client/batch/prescreen"
                  element={
                    <ClientCVPreBatch
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/client/batch/:jobId/:jobName"
                  element={
                    <ClientBatch
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/client/batch1/:jobId/:jobName"
                  element={
                    <ClientBatch1
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/client/cvs/:id"
                  element={
                    <ClientViewCvBatch
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                {/* Recruitment */}
                <Route
                  path="/recruitment"
                  element={
                    <RecruitmentLogin
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/dashboard"
                  element={
                    <RecruitmentDashboard
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/jobs"
                  element={
                    <RecruitmentJobOpenings
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruiter/jobs"
                  element={
                    <RecruiterJobs
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                {/* <Route
                  path="/recruitment/contacts"
                  element={<RecruitmentContacts />}
                ></Route> */}
                <Route
                  path="/recruitment/clients"
                  element={
                    <RecruitmentClients
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/interviews"
                  element={
                    <RecruitmentInterviews
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/tracker"
                  element={
                    <RecruitmentTrackers
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/resumes"
                  element={
                    <RecruitmentCVParsing
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/clientInformation"
                  element={
                    <RecruitmentClientInformation
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/jobAssignment"
                  element={
                    <RecruitmentJobAssignment
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/cvBatch"
                  element={
                    <RecruitmentCVBatch
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/cvBatch1"
                  element={
                    <RecruitmentCVBatch1
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/create/multipleCvBatch"
                  element={
                    <RecruitmentMultipleCVBatch
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/create/multipleCvBatch1/:id"
                  element={
                    <RecruitmentMultipleCVBatch1
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/create/viewcv/:id"
                  element={
                    <RecruitmentBatchViewCv
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/preManageClient"
                  element={
                    <PreManageClient
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/manage"
                  element={
                    <RecruitmentDetails
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/logs"
                  element={
                    <RecruitmentLogs
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/documentManage"
                  element={
                    <ManageDocument
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="/recruitment/preManageJobs"
                  element={
                    <PreManageJobs
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                {/* Misc */}
                <Route
                  path="/notAuthorized"
                  element={
                    <NotAuthorize
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
                <Route
                  path="*"
                  element={
                    <PageNotFound
                      language={language}
                      changeLanguage={changeLanguage}
                    />
                  }
                ></Route>
              </Routes>
            </LazyMotion>
          </AnimatePresence>
        </Router>
      </Suspense>
    </div>
  );
};

export default Routing;
